import { MarketingConcern } from './marketing'

export function marketing({ account, subscription }) {
  return new MarketingConcern(account, subscription)
}
